<template>
  <div class="layout">
    <div class="divrow">
      <div class="box1 divcard">
        <ul class="list1">
          <li><h2 class="text-header text-gray">Vibration Detection</h2></li>
          <!-- <li class="mt-1 mb-1 text-gray"><h4>Status</h4></li>
          <li><h2 class="text-header text-green">Normal</h2></li> -->
        </ul>
        <div class="box1list">
          <div class="box1list1">
            <img
              style="width: 80%"
              src="@/assets/images/hino element/img_vira.gif"
            />
          </div>
          <!-- <div>cccccccccccccccccc</div> -->
          <div class="box1list2" v-if="callData">
            <ul class="list1">
              <li><h4 class="textlist2 gradient1">X-Axis</h4></li>
              <li class="mt-2 mb-2 flextext">
                <p class="text-yellow marg0"><b>Speed</b></p>
                <h4 class="text-w ml-1 mr-1">{{ callData.data.x }}</h4>
                mm/s
              </li>
              <!-- <li class="flextext">
                <p class="text-purple marg0"><b>Frequency</b></p>
                <h4 class="text-w ml-1 mr-1">-0.89</h4>
                Hz
              </li> -->
            </ul>
            <br />
            <ul class="list1">
              <li><h4 class="textlist2 gradient2">Y-Axis</h4></li>
              <li class="mt-2 mb-2 flextext">
                <p class="text-yellow marg0"><b>Speed</b></p>
                <h4 class="text-w ml-1 mr-1">{{ callData.data.y }}</h4>
                mm/s
              </li>
              <!-- <li class="flextext">
                <p class="text-purple marg0"><b>Frequency</b></p>
                <h4 class="text-w ml-1 mr-1">-0.89</h4>
                Hz
              </li> -->
            </ul>
            <br />
            <ul class="list1">
              <li><h4 class="textlist2 gradient3">Z-Axis</h4></li>
              <li class="mt-2 mb-2 flextext">
                <p class="text-yellow marg0"><b>Speed</b></p>
                <h4 class="text-w ml-1 mr-1">{{ callData.data.z }}</h4>
                mm/s
              </li>
              <!-- <li class="flextext">
                <p class="text-purple marg0"><b>Frequency</b></p>
                <h4 class="text-w ml-1 mr-1">-0.89</h4>
                Hz
              </li> -->
            </ul>
          </div>
        </div>
        <ul class="listmaxmin aText">
          <li>
            <a>Date : {{ $moment(callData.timestamp).format("YYYY-MM-DD") }}</a>
          </li>
          <li>
            <a>Time : {{ $moment(callData.timestamp).format("HH:mm:ss") }}</a>
          </li>
        </ul>
      </div>
      <div class="box2">
        <div
          style="position: relative"
          class="divbox2 divcard margin-bottombox2"
        >
          <ul class="list1">
            <li><h2 class="text-header text-gray">Surface Temperature</h2></li>
            <li class="mt-2">
              <h1 class="text-w text-gray">
                {{ callData.data.temp }} <sup>°C</sup>
              </h1>
            </li>
          </ul>
          <ul class="listmaxmin">
            <li>
              <h4>
                max <a class="text-w">{{ max }} </a> °C
              </h4>
            </li>
            <li class="mt-1 mb-1">
              <h4>
                min <a class="text-w">{{ min }} </a> °C
              </h4>
            </li>
          </ul>
          <ul class="listmaxmin aText">
            <li>
              <a>
                Date : {{ $moment(callData.timestamp).format("YYYY-MM-DD") }}
              </a>
            </li>
            <li>
              <a>Time : {{ $moment(callData.timestamp).format("HH:mm:ss") }}</a>
            </li>
          </ul>
          <div>
            <img
              style="width: 40%; position: absolute; left: 0; bottom: 0"
              src="@/assets/images/hino element/chart_mathlab.gif"
            />
          </div>
        </div>
        <div class="divbox2 divcard margin-topbox2">
          <div class="header-surface-graph">
            <h4 class="text-w text-gray">Surface Temperature Graph</h4>
            <vs-spacer></vs-spacer>
            <vs-select v-model="select1" width="120px" @change="selectchart">
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in options1"
              />
            </vs-select>
          </div>
          <LineChart
            v-if="chartData.labels[0] != undefined"
            :height="150"
            :chartData="chartData"
            :optionsChart="optionsChart"
          />
          <!-- <LineChart
            v-if="chartData != undefined"
            :height="150"
            :chartdata="chartData"
            :options="optionsChart"
          /> -->
          <div class="bottom-surface-graph">
            <div class="legend-box">
              <div class="legend"></div>
              Surface Temperature
            </div>
            <div class="bottom-right-surface-graph">
              <div class="box-chart">
                <p id="avg">avg</p>
                <p>{{ avg.toFixed(2) }}°C</p>
              </div>
              <div class="box-chart">
                <p id="min">min</p>
                <p>{{ min }}°C</p>
              </div>
              <div class="box-chart">
                <p id="max">max</p>
                <p>{{ max }}°C</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box3 divcard">
        <h4 class="text-w mb-2 text-gray">Temperature Timeseries</h4>
        <b-table-simple
          style="overflow-y: auto; max-height: 400px"
          hover
          responsive="sm"
        >
          <b-thead style="position: sticky; top: 0; z-index: 2">
            <b-tr class="bgHeader">
              <b-th>Timestamp</b-th>
              <b-th>Surface Temperature</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="i in data" :key="i">
              <b-td class="texttabl2" align="center">{{ i.date }}</b-td>
              <b-td class="texttabl2" align="center">{{ i.temp }} °C</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
    </div>
    <div class="divrow">
      <div class="divcard p-3">
        <chartlarge
          :text="'Vibration Sensor Graph'"
          :colorgraph="borderColorP"
          :heightgrapg="300"
          :id="$route.path == '/EngineAssemblyLine' ? '6' : '7'"
          :datachart="rawChartData"
          v-if="rawChartData!=undefined"
        />
        <!-- <chart-stock
          :dataA="dataA"
          :dataB="dataB"
          :dataC="dataC"
          v-if="dataC.length > 0"
        /> -->
      </div>
      <!-- <div class="divcard p-3" id="card-stockchart">
        <chart-stock
          :dataA="dataA"
          :dataB="dataB"
          :dataC="dataC"
          v-if="dataC.length > 0"
        />
      </div> -->
    </div>
  </div>
</template>

<script>
// import LineChart from "../components/BodyOutLine/Chart.js";
import LineChart from "@/components/ChartJs/LineChart.js";

import ChartStock from "./ChartStock.vue";
import chartlarge from "./../components/assembly_con/linechart_large.vue";
export default {
  components: { ChartStock, LineChart, chartlarge },
  data() {
    return {
      backgroundColorP: "rgba(20, 153, 242,.1)",
      borderColorP: "rgba(20, 153, 242)",
      options1: [
        { text: "3 hr", value: 4 },
        { text: "6 hr", value: 2 },
        { text: "12 hr", value: 1 },
      ],
      select1: 4,
      chartData: {
        datasets: [
          {
            label: "Temperature ( °C )",
            data: [],
            borderWidth: 2,
            borderColor: "#007bff",
            backgroundColor: "#0000",
            pointBorderWidth: 1,
          },
        ],
        labels: [
          "02-23 08:00",
          "02-24 08:00",
          "02-25 08:00",
          "02-26 08:00",
          "02-27 08:00",
          "02-28 08:00",
        ],
      },
      optionsChart: {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: false,
          title: {},
          position: "bottom",
        },
        scales: {
          yAxes: [
            {
              // id: "A",
              ticks: {
                // beginAtZero: true,
                // fontColor: "#ffffff",
                step: 1,
              },
              // position: "left",
              scaleLabel: {
                display: true,
                labelString: "Temperature ( °C )",
              },
            },
          ],
        },
      },
      data: [],
      dataB: [],
      dataC: [],
      dataA: [],
      interval: null,
      callData: {},
      rawChartData: undefined,
      max: 0,
      min: 0,
      avg: 0,
    };
  },
  async mounted() {
    this.getTemp7Days();
    this.geChart();
  },
  beforeDestroy() {
    clearTimeout(this.interval);
  },
  methods: {
    async getTemp7Days() {
      let res;
      if (this.$route.path == "/EngineAssemblyLine") {
        res = await this.$API.get(`hino/getweekly/6`);
      } else {
        res = await this.$API.get(`hino/getweekly/7`);
      }
      console.log("hino/getweeklyk/", res);

      this.data = res.data.reverse();
    },
    async geChart() {
      if (this.$route.path == "/EngineAssemblyLine") {
        this.callData = await this.$API.get("hino/getinfo/6");
        console.log("hino/getinfo/",this.callData);
        this.callData = this.callData.data;
        let res = await this.$API.get(`hino/getchart/6`);
        console.log("hino/getchart6", res);
        this.rawChartData = res.data;
      } else {
        this.callData = await this.$API.get("hino/getinfo/7");
        console.log("hino/getinfo/",this.callData);

        this.callData = this.callData.data;
        let res = await this.$API.get(`hino/getchart/7`);
        console.log("hino/getchart7", res);
        this.rawChartData = res.data;
      }
      this.selectchart();

      this.interval = setTimeout(() => {
      this.geChart();
    }, 1000 * 10);
    },
    selectchart() {
      let index =
        this.rawChartData.timestamp.length -
        Math.round(this.rawChartData.timestamp.length / this.select1);
      let total = 0;
      this.max = Number(
        this.rawChartData.temp[this.rawChartData.temp.length - 1]
      );
      this.min = Number(
        this.rawChartData.temp[this.rawChartData.temp.length - 1]
      );

      console.log("change datachart");
      let newdata = this.rawChartData.temp.slice(index);
      let newlabels = this.rawChartData.timestamp.slice(index);
      let NumData = [];
      let foematLabels = [];
      // console.log(newdata);
      for (let i = 0; i < newdata.length; i++) {
        const el = newdata[i];
        // console.log(Number(el));
        NumData.push(Number(el));
        foematLabels.push(this.$moment(newlabels[i]).format("HH:mm"));
        this.max = Number(el) > this.max ? Number(el) : this.max;
        this.min = Number(el) < this.min ? Number(el) : this.min;
        total += Number(el);
      }
      this.avg = total / newdata.length;
      this.chartData.datasets[0].data = NumData;
      this.chartData.labels = foematLabels;
      console.log(this.chartData);
    },
  },
};
</script>

<style  scoped>
.bgHeader {
  background: #32c040;
  color: #ffffff;
  /* font-size: 0.78rem; */
}
.legend-box {
  display: flex;
  align-items: center;
  gap: 5px;
}
.legend {
  width: 30px;
  height: 15px;
  background-color: #007bff;
  border-radius: 5px;
}
.layout {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  gap: 15px;
}
.box-chart {
  display: flex;
  flex-direction: column;
  align-items: center;
}
#avg {
  font-weight: 800;
  margin-bottom: 0.5rem;
  color: #ffa807;
}
#min {
  font-weight: 800;
  margin-bottom: 0.5rem;
  color: #f707ff;
}
#max {
  font-weight: 800;
  margin-bottom: 0.5rem;
  color: #8f07ff;
}
.header-surface-graph {
  display: flex;
  align-items: center;
}
.bottom-surface-graph {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.bottom-right-surface-graph {
  display: flex;
  align-items: center;
  gap: 10px;
}
.texttabl2 {
  color: var(--text-color);
}
.divcard {
  width: 100%;
  height: auto;
  background: var(--background-color-sidebar);
  color: var(--text-color);
  border-radius: 20px;
  /* margin-bottom: 20px; */
  display: block;
  -webkit-box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%);
  box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.divrow {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  /* align-items: center; */
}
.box1 {
  width: 35%;
  padding: 15px;
  display: grid;
  align-items: center;
}
.box2 {
  display: flex;
  flex-direction: column;
  width: 35%;
  padding: 0 15px;
}
.box3 {
  width: 30%;
  padding: 15px;
}
.item-flex {
  display: flex;
  /* justify-content: center; */
}
.aText {
  font-size: 0.7rem;
}
.divbox2 {
  height: auto;
  padding: 15px;
}
.text-header {
  font-size: 1.6rem;
  font-weight: 700;
}
.text-w {
  font-weight: 700;
}
.text-green {
  color: #32c040;
}
.text-gray {
  color: #808080;
}
.text-purple {
  color: #6f42c1;
}
.text-yellow {
  color: #ffc107;
}
.margin-topbox2 {
  margin-top: 7.5px;
}
.margin-bottombox2 {
  margin-bottom: 7.5px;
}
.list1 {
  display: grid;
  list-style: none;
  justify-content: center;
  justify-items: center;
  margin: 2%;
}
.listmaxmin {
  display: grid;
  list-style: none;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: end;
  margin: 2%;
}
.box1list {
  display: flex;
  align-items: center;
  flex-direction: row;
  align-content: center;
  justify-content: space-around;
}
.box1list1 {
  width: 50%;
  display: grid;
  justify-items: center;
}
.box1list2 {
  width: 50%;
  display: grid;
  justify-items: center;
}
.marg0 {
  margin-bottom: 0;
}
.textlist2 {
  /* background: linear-gradient(90deg, #00C9FF 0%, #92FE9D 100%); */
  border-radius: 20px;
  padding: 0 10px;
}
.gradient1 {
  background: linear-gradient(
    90deg,
    rgb(247, 141, 84) 0%,
    rgb(247, 141, 84) 100%
  );
  /* font-weight: 500; */
}
.gradient2 {
  background: linear-gradient(90deg, #92fe9d 0%, #92fe9d 100%);
  /* font-weight: 500; */
}
.gradient3 {
  background: linear-gradient(90deg, #fa7ba5 0%, #fa7ba5 100%);
  /* font-weight: 500; */
}
.flextext {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
@media only screen and (max-width: 700px) {
  .box1 {
    width: 100%;
  }
  .box2 {
    width: 100%;
    padding: 15px 0;
    /* height: 100%; */
  }
  .box3 {
    width: 100%;
  }
}
</style>